import api from "../../api"
import { PaymentScheduleOptions } from "../../../domain/proposals/settings/proposalSettings"
import { Proposal, ProposalEvent, ProposalSummary } from "./proposalsModel"

export const proposalsEndpoint = `/web/proposals`

export const getProposals = async (jobId: number): Promise<Proposal[]> => {
  return (await api.get<Proposal[]>(`${proposalsEndpoint}/${jobId}`)).data
}

export const getProposalSummary = async (jobId: number): Promise<ProposalSummary> => {
  return (await api.get<ProposalSummary>(`${proposalsEndpoint}/${jobId}/summary`)).data
}

export const getProposalPaymentSchedule = async (proposalId: number): Promise<PaymentScheduleOptions> => {
  return (await api.get<PaymentScheduleOptions>(`${proposalsEndpoint}/payment-schedule-options/${proposalId}`)).data
}

export const getProposalEvents = async (proposalId: number): Promise<ProposalEvent[]> => {
  return (await api.get<ProposalEvent[]>(`${proposalsEndpoint}/${proposalId}/events`)).data
}

export const createExistingProposalLink = async (proposalId: number): Promise<string> => {
  return (await api.post<string>(`${proposalsEndpoint}/link/${proposalId}`)).data
}

export const createPreviewLink = async (proposalId: number): Promise<string> => {
  return (await api.post<string>(`${proposalsEndpoint}/preview-link/${proposalId}`)).data
}

export const createAttachmentUrl = async (attachmentId: string): Promise<string> => {
  return (await api.post<string>(`${proposalsEndpoint}/attachment-url/${attachmentId}`)).data
}

export const disableFollowUp = async (proposalId: number, customerUserId: string): Promise<string> => {
  return (await api.post<string>(`${proposalsEndpoint}/disable/${proposalId}/customer-user/${customerUserId}`)).data
}